// extracted by mini-css-extract-plugin
export default {"container":"BreadCrumb_container__cIJaU","normal":"BreadCrumb_normal__RulC6","strong":"BreadCrumb_strong__-WBDL","icon":"BreadCrumb_icon__EWKJi"};